import ContainerModules from "./containerModules";
import OffersHeader from "./offersHeader";

const OffersWidget = ({ directNumber, ticketId }) => {
    return (
        <>
            <OffersHeader />
            <ContainerModules directNumber={directNumber} ticketId={ticketId} />
        </>
    );
};

export default OffersWidget;
